<template>
  <v-row dense>
    <v-col cols="12" sm="12">
      <v-card>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="12" md="3">
              <SelectCampanha
                :independent="true"
                @onChanged="campanha = $event"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" sm="12">
      <v-card>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="12" md="12" align="center" justify="center">
              <div class="mb-2">
                <v-btn
                  v-if="!inputImage"
                  color="blue darken-2"
                  rounded
                  outlined
                  dark
                  small
                  @click="$refs.inputImage.click()"
                >
                  <v-icon left>mdi-image</v-icon>Selecionar Imagens para PDF
                </v-btn>

                <v-btn
                  v-if="inputImage"
                  color="orange darken-2"
                  rounded
                  outlined
                  dark
                  small
                  @click="$refs.inputImage.click(), pageNum = 1"
                >
                  <v-icon left>mdi-image</v-icon>Alterar Imagens
                </v-btn>

                <input
                  ref="inputImage"
                  type="file"
                  accept="image/*"
                  multiple
                  style="display: none"
                  @change="onImageChanged($refs.inputImage.files)"
                />
              </div>

              <v-skeleton-loader
                  class="mx-auto"
                  :transition="'fade-transition'"
                  type="card"
                  :loading="!inputImage"
              >
                <div class="text-center">
                  <canvas
                    ref="canvas"
                    :width="canvasSettings.width"
                    :height="canvasSettings.height"
                    class="elevation-3"
                  >
                  </canvas>
                  <div class="mt-2">
                    <v-btn color="black" x-small fab icon @click="onPrevPage()">
                      <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    <span style="font-weight: bold">Página: {{ pageNum }} de {{ pageCount }}
                    </span>
                    <v-btn
                      color="black"
                      class="ml-1"
                      x-small
                      fab
                      icon
                      @click="onNextPage()"
                    >
                      <v-icon>mdi-arrow-right</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-skeleton-loader>
            </v-col>

          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-row align="center" justify="center">
            <v-btn v-if="inputImage" color="primary" outlined rounded small @click="save()">
              <v-icon left>mdi-content-save</v-icon>Salvar
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import fonts from "@/utils/fonts"
import { LayoutPdf } from "@/services/materiais"

export default {
  name: "CreateLayoutImage",

  components: {
    SelectCampanha: () => import("@/components/select/SelectCampanha"),
  },

  data() {
    return {
      inputImage: null, // imagem selecionada
      blobImage: null, // blob da imagem
      canvasImage: null, // imagem atual renderizada no canvas
      objetos: [], // objetos que serão desenhados no canvas

      campanha: null,

      canvas: null,
      context: null,
      canvasSettings: {
        width: 453 /*425.19*/,
        height: 642 /*595.27*/
      },
      pageNum: 1,
      pageCount: 1,

      fonts: fonts,
      font: {
        value: "Arial",
        bold: "bold",
        italic: "normal",
        color: "#000000"
      }
    };
  },

  methods: {
    onImageChanged(files) {
      if (files.length > 0) {
        let file = files[this.pageNum - 1];
        if (!file.type.includes("image/")) {
          this.$toast.warning("Selecione um arquivo do tipo imagem");
          return;
        }

        let reader = new FileReader();
        reader.onload = e => {
          this.blobImage = e.target.result;
          this.setImageCanvas();
        };
        reader.readAsDataURL(file);

        this.inputImage = files;
        this.pageCount = files.length;
      }
    },

    setImageCanvas() {
      let image = new Image();

      image.onload = () => {
        this.updateCanvas();
      };

      image.src = this.blobImage;
      this.canvasImage = image;
      this.setCanvas()
    },

    onPrevPage() {
      if(!this.inputImage || this.pageNum <= 1) return
      this.pageNum--
      this.onImageChanged(this.inputImage)
    },

    onNextPage() {
      if(!this.inputImage || this.pageNum >= this.pageCount) return
      this.pageNum++
      this.onImageChanged(this.inputImage)
    },

    updateCanvas() {
      if (this.canvasImage) {
        this.context.drawImage(
          this.canvasImage,
          0,
          0,
          this.canvasSettings.width,
          this.canvasSettings.height
        );

        this.context.fillStyle = this.font.color;

        for (let objeto of this.objetos) {
          let font = `${this.font.bold} ${this.font.italic} ${objeto.size}px ${this.font.value}`;
          this.context.font = font;
          this.context.fillText(objeto.text.toUpperCase(), objeto.x, objeto.y);
        }
      }
    },

    async save() {
      if (!this.campanha) {
        this.$toast.warning("Selecione uma campanha");
        return;
      }
      if (!this.inputImage || !this.blobImage || !this.canvasImage) {
        this.$toast.warning("Selecione uma imagem");
        return;
      }

      let descricao = await this.$swal.inputText(
        "Descrição do Layout",
        true,
        "Descrição"
      );
      if (!descricao || descricao == "") {
        this.$toast.warning("É necessário informar descrição da template");
        return;
      }

      try {
        descricao = descricao.replaceAll("/", "-");
        let data = {
          descricao: descricao,
          objetos: this.objetos,
          campanha: this.campanha,
          font: this.font
        };

        this.$loading.setLoading(true);
        let result = await new LayoutPdf().createImagesForPDF(data, this.inputImage, this.inputImage.length);
        this.$toast.success(result);
        this.$router.push("/materiais/layouts");
      } catch (error) {
        this.$toast.error(error);
      } finally {
        this.$loading.setLoading(false);
        this.mensagem()
      }
    },

    setCanvas() {
      this.canvas = !this.canvas ? this.$refs.canvas : this.canvas
      this.context = !this.context ? this.canvas.getContext("2d") : this.context
    },

    async mensagem(){
      let confirm = await this.$swal.confirm("Deseja notificar os colaboradores a disponibilidade do novo material ?");
      console.log("confirm", confirm);
      if(confirm){
        this.$router.push("/notificacao")
      }
    }
  },

  watch: {
    objetos: {
      handler() {
        this.updateCanvas();
      },
      deep: true
    },

    font: {
      handler() {
        this.updateCanvas();
      },
      deep: true
    }
  },
};
</script>

<style lang="scss">
.swatch-style {
  cursor: pointer !important;
  height: "30px" !important;
  width: "30px" !important;
  border-radius: 4px;
  padding: 10px;
}
</style>
